import {
  Box,
  Breadcrumbs,
  Button,
  Card,
  CardContent,
  CardHeader,
  Container,
  makeStyles,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { Field, Form, Formik } from "formik";
import { TextField } from "formik-material-ui";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import {
  deleteRemarkDetail,
  getRemarkDetail,
  saveRemarkDetail,
} from "src/redux/actions/purchaseRequest.action";
import { isAllowed } from "src/utils/Auth";
import Page from "src/components/Page";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    flexWrap: "wrap",
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "26ch",
    },
    "& .MuiFormControlLabel-root": {
      margin: theme.spacing(1),
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  remarkText: {
    borderLeft: 5,
    borderRight: 0,
    borderTop: 0.5,
    borderBottom: 0,
    borderStyle: "solid",
    borderColor: "grey",
    fontSize: 17,
    padding: (10, 20),
    margin: (0, 0, 20),
    fontStyle: "italic",
  },
  breadcrumbContainer: {
    display: "flex",
    flex: 1,
    flexWrap: "wrap",
    justifyContent: "center",
  },
  formContainer: {
    display: "flex",
    flex: 1,
    flexWrap: "wrap",
    justifyContent: "center",
  },
  rootLoading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 400,
    padding: 5,
  },
  selectInputForm: {
    margin: theme.spacing(1, 1, 1),
    width: "25ch",
  },
}));

export default function RemarkEditComponent() {
  const params = useParams();
  const classes = useStyles();
  const form = useRef();
  const history = useHistory();
  const dispatch = useDispatch();

  const [remarkValue, setRemarkValue] = useState({
    ID: "",
    PRDIDX: params.id,
    REMARK_TEXT: "",
  });

  const { authorizePR } = useSelector((state) => state.authorizationReducer);

  const { purchaseRequestDetailRemark, purchaseRequest } = useSelector(
    (state) => state.purchaseRequestReducer
  );

  useEffect(() => {
    if (form.current) {
      form.current.getFormikActions().validateForm();
    }

    if (params.id) {
      dispatch(getRemarkDetail(params.id));
      setRemarkValue({
        ID: "",
        PRDIDX: params.id,
        REMARK_TEXT: "",
      });
    }

    return () => {};
  }, [params.id]);

  return (
    <Page className={classes.root} title="Item Remark Form">
      <Container maxWidth={false}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link
            color="inherit"
            onClick={(e) => {
              e.preventDefault();
              history.replace("/purchase-requisition-list");
            }}
          >
            Purchase Requisition List
          </Link>
          <Link
            color="inherit"
            onClick={(e) => {
              e.preventDefault();
              history.goBack();
            }}
          >
            Purchase Requesition Edit
          </Link>
          <Link color="textPrimary" aria-current="page">
            Remark Form
          </Link>
        </Breadcrumbs>
        <Card>
          <CardHeader
            subheader="For the purchase requisition add/edit item remark on the system."
            title="Item Remark Form"
          />
          <CardContent>
            <Box display="flex" flex={1} flexDirection="column">
              <Box>
                {purchaseRequest.data.PR_STATUS < 20 &&
                  isAllowed(authorizePR.data, ["can_add_remark"]) && (
                    <Formik
                      ref={form}
                      enableReinitialize
                      initialValues={remarkValue}
                      onSubmit={(values, { setSubmitting, resetForm }) => {
                        setTimeout(() => {
                          dispatch(saveRemarkDetail(values));
                          resetForm({
                            value: "",
                          });
                          setRemarkValue({
                            ID: "",
                            PRDIDX: params.id,
                            REMARK_TEXT: "",
                          });
                          setSubmitting(false);
                        }, 500);
                      }}
                      validate={(values) => {
                        const errors = {};

                        if (!values.REMARK_TEXT) {
                          errors.REMARK_TEXT = "Required";
                        }

                        if (values.REMARK_TEXT.length > 40) {
                          errors.REMARK_TEXT =
                            "The remark can be max 40 charactors long.";
                        }

                        return errors;
                      }}
                    >
                      {(formikProps) => {
                        const {
                          submitForm,
                          isSubmitting,
                          touched,
                          errors,
                          values,
                          setFieldValue,
                        } = formikProps;

                        return (
                          <Form noValidate>
                            <div>
                              <Box display="flex" flexDirection="column">
                                <Box display="flex">
                                  <Field
                                    component={TextField}
                                    name="REMARK_TEXT"
                                    label="Remark"
                                    multiline
                                    style={{
                                      width: "100%",
                                    }}
                                    rows={4}
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                  />
                                </Box>
                                <Box
                                  p={2}
                                  display="flex"
                                  justifyContent="flex-end"
                                >
                                  <Box>
                                    <Button
                                      color="primary"
                                      variant="contained"
                                      onClick={submitForm}
                                    >
                                      <AddIcon />
                                      Save
                                    </Button>

                                    <Button
                                      variant="contained"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        history.goBack();
                                      }}
                                    >
                                      Back
                                    </Button>
                                  </Box>
                                </Box>
                              </Box>
                            </div>
                          </Form>
                        );
                      }}
                    </Formik>
                  )}
              </Box>
              <Box>
                {purchaseRequestDetailRemark.data &&
                  purchaseRequestDetailRemark.data.map((i) => (
                    <div>
                      <blockquote className={classes.remarkText}>
                        <Box display="flex" flex={1}>
                          <Box flexGrow={1}>
                            <p>{i.REMARK_TEXT}</p>
                            <small>- {i.CREATED_AT}</small>
                          </Box>
                          <Box>
                            {purchaseRequest.data.PR_STATUS < 20 &&
                              isAllowed(authorizePR.data, [
                                "can_edit_remark",
                              ]) && (
                                <Button
                                  variant="contained"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setRemarkValue({
                                      ...remarkValue,
                                      ID: i.ID,
                                      REMARK_TEXT: i.REMARK_TEXT,
                                    });
                                  }}
                                >
                                  <EditIcon /> Edit
                                </Button>
                              )}

                            {purchaseRequest.data.PR_STATUS < 20 &&
                              isAllowed(authorizePR.data, [
                                "can_delete_remark",
                              ]) && (
                                <Button
                                  variant="contained"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    Swal.fire({
                                      title: "Confirm to delete remark ?",
                                      text: "You won't be able to revert this!",
                                      icon: "warning",
                                      showCancelButton: true,
                                      confirmButtonColor: "#3085d6",
                                      cancelButtonColor: "#d33",
                                      confirmButtonText: "Delete",
                                    }).then((result) => {
                                      if (result.isConfirmed) {
                                        dispatch(
                                          deleteRemarkDetail(i.ID, params.id)
                                        );
                                      }
                                    });
                                  }}
                                >
                                  <DeleteIcon /> Remove
                                </Button>
                              )}
                          </Box>
                        </Box>
                      </blockquote>
                    </div>
                  ))}
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
}
